function getCountry(_this) {
  _this.$axios({
    method: 'post',
    // url: Vue.prototype.api + '6003/api/local/getCountry'
    url: Vue.prototype.api + 'api/local/getCountry'
  }).then((response) => {
    if (response.status == 200) {
      if (response.data.code == '200') {

        sessionStorage.setItem("listCountry", JSON.stringify(response.data.data));
        return;
      } else if (response.data.code == '210') {
        _this.$notify.error({
          title: _this.$t("App.notify.title_server"),
          message: _this.$t("App.notify.content_entitiesept")
        });
        return;
      } else {

        _this.$notify.error({
          title: _this.$t("App.notify.title_server"),
          message: _this.$t("App.notify.content_servererr")
        });
        return;
      }
    } else {
      _this.$notify.error({
        title: _this.$t("App.notify.title_server"),
        message: _this.$t("App.notify.content_server") + response.status
      });
      return;
    }
  }).catch((error) => {
    _this.$notify.error({
      title: _this.$t("App.notify.title_server"),
      message: _this.$t("App.notify.content_servererr")
    });
    return;
  });
}

import Vue from 'vue';

export {
  getCountry
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js